const CHILD_TERMS = ['child', 'children', 'kid', 'kids', 'baby', 'babies', 'toddler', 'infant', 'schoolchild', 'minor', 'juvenile'];

// Blocks manually-pasted image URLs that reference children, since these
// images bypass the vetted Pexels search and are never reviewed otherwise.
export const isDisallowedImageUrl = (url) => {
  const lower = url.toLowerCase();
  return CHILD_TERMS.some(t => lower.includes(t));
};
